import axios from "axios";

// Shared axios instance for the Offers feature.
// - baseURL points to the backend /api prefix
// - withCredentials sends the httpOnly `oj_admin_token` cookie
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Backend returns file URLs relative to the API (e.g. "/api/uploads/offers/xyz.png").
// Convert to absolute for use in <img src>.
export function absUploadUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL || ""}${url}`;
}
